import React, { useState } from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { TextBox } from ".";

const HoverTextBox = (props) => {
  const [active, setActive] = useState(false);

  const handleMouseEnter = () => {
    setActive(true);
  };

  const handleMouseLeave = () => {
    setActive(false);
  };

  return (
    <>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <TextBox
          title={props.text}
          symbol={props.symbol}
          height={10}
          circleSize={"50px"}
          iconSize={25}
          circleBorder={true}
          active={active}
          width="100%"
        />
      </div>
    </>
  );
};

export default HoverTextBox;
